import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const LogoutRepresentativeCommand = (
  repository: IRepresentativeRepository,
  refreshToken: string,
) => {
  return repository.logout(refreshToken)
}
